import type { ChiTietPhieuNhapKho, PhieuNhapKhoAmount } from '@/types/schemas';
import type { FileDef } from '@/lib/excel/export/types';
import { exportDetails } from '@/lib/excel/export';

type PhieuNhapKhoDetailExportRow = ChiTietPhieuNhapKho & { exportLine: string };

const toNumber = (value: PhieuNhapKhoAmount | null | undefined) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const textValue = (value: unknown) => (typeof value === 'string' ? value : '');

const displayedAmount = (row: ChiTietPhieuNhapKho) => {
  if (row.tien_nt !== null && row.tien_nt !== undefined && row.tien_nt !== '') return toNumber(row.tien_nt);
  return toNumber(row.gia_nt) * toNumber(row.so_luong);
};

export const PHIEU_NHAP_KHO_DETAIL_FILE: FileDef<PhieuNhapKhoDetailExportRow> = {
  name: 'ChiTietPhieuNhapKho',
  sheet: 'Chi tiết phiếu nhập kho',
  title: 'CHI TIẾT PHIẾU NHẬP KHO',
  cols: [
    { header: 'Dòng', width: 8, get: row => row.exportLine },
    { header: 'Mã sản phẩm', width: 20, get: row => row.ma_vt_data?.ma_vt || textValue(row.ma_vt) },
    { header: 'Tên sản phẩm', width: 35, get: row => row.ma_vt_data?.ten_vt || '' },
    {
      header: 'Đvt',
      width: 12,
      get: row =>
        (typeof row.dvt === 'object' ? row.dvt?.dvt : row.dvt) || row.dvt_data?.dvt || row.ma_vt_data?.dvt || ''
    },
    {
      header: 'Mã kho',
      width: 16,
      get: row => row.ma_kho_data?.ma_kho || row.ma_vt_data?.ma_kho_data?.ma_kho || textValue(row.ma_kho)
    },
    { header: 'Số lượng', width: 14, get: row => toNumber(row.so_luong) },
    { header: 'Giá trung bình', width: 16, get: row => Boolean(row.pn_tb) },
    { header: 'Giá VND', width: 16, get: row => toNumber(row.gia_nt) },
    { header: 'Tiền VND', width: 18, get: displayedAmount },
    { header: 'Tk nợ', width: 12, get: row => row.tk_vt_data?.code || textValue(row.tk_vt) },
    { header: 'Lý do nhập', width: 16, get: row => row.ma_nx_data?.ma_nx || textValue(row.ma_nx) },
    {
      header: 'Tk có',
      width: 12,
      get: row => row.tk_du_data?.code || row.ma_nx_data?.tk_data?.code || textValue(row.tk_du)
    },
    { header: 'Bộ phận', width: 16, get: row => row.ma_bp_data?.ma_bp || textValue(row.ma_bp) },
    {
      header: 'Vụ việc',
      width: 16,
      get: row => row.ma_vv_data?.ma_vu_viec || row.ma_vv_data?.ma_vv || textValue(row.ma_vv)
    },
    { header: 'Hợp đồng', width: 16, get: row => row.ma_hd_data?.ma_hd || textValue(row.ma_hd) },
    { header: 'Đợt thanh toán', width: 18, get: row => row.ma_dtt_data?.ma_dtt || textValue(row.ma_dtt) },
    { header: 'Khế ước', width: 16, get: row => row.ma_ku_data?.ma_ku || textValue(row.ma_ku) },
    { header: 'Phí', width: 14, get: row => row.ma_phi_data?.ma_phi || textValue(row.ma_phi) },
    {
      header: 'Lệnh sản xuất',
      width: 20,
      get: row => row.ma_lsx_data?.so_ct || row.ma_lsx_data?.ma_lsx || textValue(row.ma_lsx)
    },
    {
      header: 'C/p không h/lệ',
      width: 18,
      get: row => row.ma_cp0_data?.ma_cpkhl || row.ma_cp0_data?.ma_cp || textValue(row.ma_cp0)
    },
    { header: 'Số lệnh SX', width: 18, get: row => row.ma_lsx_data?.ma_lsx || '' },
    { header: 'Dòng lệnh SX', width: 16, get: row => String(row.line_sx1 ?? '') }
  ]
};

export const exportPhieuNhapKhoDetailsToExcel = (rows: ChiTietPhieuNhapKho[], documentNumber?: string) =>
  exportDetails(
    rows.map((row, index) => ({ ...row, exportLine: String(index + 1) })),
    {
      file: PHIEU_NHAP_KHO_DETAIL_FILE,
      documentNumber,
      successMessage: 'Kết xuất chi tiết phiếu nhập kho thành công.',
      errorMessage: 'Không thể kết xuất chi tiết phiếu nhập kho.'
    }
  );
